import { LockIcon } from "../../../../feature-components/ChatBox/LockIcon.tsx";
import styles from "./styles.module.css";

export function KnowledgeSource(props: {
  knowledgeSource: string | undefined;
}) {
  return (
    <div
      className={styles.KnowledgeSource}
      title="You can only select a knowledge source during workflow creation. Once selected, the knowledge source is locked for this workflow and cannot be changed."
    >
      {props.knowledgeSource} <LockIcon className={styles.Icon} />
    </div>
  );
}
